// Maps the guided cash-out UI selection to the API request body for
// POST /games/{gameId}/players/{playerId}/cash-out.
//
// In the UI a cover carries the whole buy-in transaction (so the screen can
// show its amount/method); the API only needs the buy-in's id and the cover
// amount. Payouts pass through unchanged. The API owns the business rules
// (creating the covers, settling fully-covered buy-ins, recording the payouts).
export function buildCashOutRequest({ covers = [], payouts = [] }) {
    return {
        covers: covers.map(({ transaction, amount }) => ({
            buyInId: transaction.id,
            amount,
        })),
        payouts: payouts.map(({ paymentType, amount, isSettled }) => ({
            paymentType,
            amount,
            isSettled,
        })),
    };
}
